module.exports = __webpack_public_path__ + "img/K6.18a71c44.png";